import { SPEECH_REGION, SPEECH_REGION_REPLACE } from '../../constants';
import { AzureVoice } from '../../models/azure';
import endpoints from './endpoints.json';

let cachedVoiceToken: AzureVoice | null = null;
let voiceTokenExpiresAt = 0;
let voiceTokenRequest: Promise<AzureVoice> | null = null;

const getAzureVoiceToken = async (): Promise<AzureVoice> => {
  // Azure Speech tokens tienen una validez de 10 minutos. Renovamos con
  // margen y compartimos la misma petición si varias operaciones arrancan
  // simultáneamente (STT y TTS suelen hacerlo al iniciar una conversación).
  if (cachedVoiceToken && Date.now() < voiceTokenExpiresAt) {
    return cachedVoiceToken;
  }

  if (voiceTokenRequest) {
    return voiceTokenRequest;
  }

  voiceTokenRequest = (async () => {
    const response = await fetch(
      `${process.env.REACT_APP_AZURE_SPEECH_API?.replace(
        SPEECH_REGION_REPLACE,
        SPEECH_REGION
      )}${endpoints.post.azureSpeech}`,
      {
        method: 'POST',
        headers: {
          'Ocp-Apim-Subscription-Key': process.env
            .REACT_APP_AZURE_SPEECH_KEY as string,
        },
      },
    );

    if (!response.ok) {
      throw new Error(`Error obteniendo token de Azure Speech: ${response.status}`);
    }

    const authToken = await response.text();
    const token = { authToken, region: SPEECH_REGION };
    cachedVoiceToken = token;
    // Renovar al minuto 9 para evitar usar un token a punto de caducar.
    voiceTokenExpiresAt = Date.now() + 9 * 60 * 1000;
    return token;
  })();

  try {
    return await voiceTokenRequest;
  } finally {
    voiceTokenRequest = null;
  }
};

export { getAzureVoiceToken };
